import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'paymentStatusDrawer.title',
    defaultMessage: 'Change payment status',
    description: 'title of the payment status drawer',
  },
  feedback: {
    paymentStatusChanged: {
      id: 'paymentStatusDrawer.feedback.paymentStatusChanged',
      defaultMessage: 'Payment status changed',
      description: 'Payment status change success message',
    },
    paymentStatusNotChanged: {
      id: 'paymentStatusDrawer.feedback.paymentStatusNotChanged',
      defaultMessage: 'Payment status could not be changed',
      description: 'Payment status change error message',
    },
  },
};

export default defineMessages(translations);
